export default __webpack_public_path__ + "static/media/Heilmassage.5ad79e23.jpeg";